/* 🤖 this file was generated by script */
export const wiconCreditCard02 = {
  name: 'credit_card_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 10H2m9 4H6M2 8.2v7.6c0 1.12 0 1.68.22 2.1.19.38.5.69.87.88.43.22.99.22 2.11.22h13.6c1.12 0 1.68 0 2.1-.22a2 2 0 00.88-.87c.22-.43.22-.99.22-2.11V8.2c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C2 6.52 2 7.08 2 8.2z"/></svg>`,
};
